import * as $ from 'jquery';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import {on, onLoad, onSubmit} from 'Core/Events';
import {PlannerSubProcessCommon} from "Components/Planner/PlannerSubProcessCommon";

export class ServiceSavePlannerProject extends PlannerSubProcessCommon {

    private static buffer;
    private static png;
    private static jsonData;
    private static items;

    private static isSaveClicked = false;

    @on('eventLoginModalHasBeenClosed', ServiceSavePlannerProject.loadAndDisplayModalSaveProjectForUnlogged, PlannerSelectors.LOGIN_PANEL)
    @onSubmit(PlannerSelectors.MODAL.SAVE_FOR_UNLOGGED.FORM, ServiceSavePlannerProject.initSaveProjectForUnlogged)
    @onSubmit(PlannerSelectors.LOGIN_FORM, ServiceSavePlannerProject.saveProjectBeforeLogin)
    @onLoad(ServiceSavePlannerProject.showModalOnInit)

    public init(buffer, png, jsonData, items) {
        ServiceSavePlannerProject.buffer = buffer;
        ServiceSavePlannerProject.png = png;
        ServiceSavePlannerProject.jsonData = jsonData;
        ServiceSavePlannerProject.items = items;
        ServiceSavePlannerProject.isSaveClicked = true;

        ServiceSavePlannerProject.isUserLogged()
            .done((response) => {
                if (response.logged) {
                    ServiceSavePlannerProject.initSaveProjectForLogged();
                } else {
                    if($(PlannerSelectors.TOOGLER).length > 0){
                        $(PlannerSelectors.TOOGLER).click();
                    } else {
                        ServiceSavePlannerProject.loadAndDisplayModalSessionHasExpired();
                        ServiceSavePlannerProject.emergencyLoadingOfLoginForm()
                            .done(() => {
                                $(PlannerSelectors.TOOGLER).click();
                            })
                    }
                }
            });
    }

    public static loadAndDisplayModalSaveProjectForUnlogged(e) {
        if (ServiceSavePlannerProject.isSaveClicked) {
            ServiceSavePlannerProject.setSpinnerOnModal();
            ServiceSavePlannerProject.modalOn();
            ServiceSavePlannerProject.loadModalSaveProjectForUnlogged()
                .done((response) => {
                    ServiceSavePlannerProject.setContentOnModal(response)
                });
        }
    }

    /**
     * Inicjacja procesu przeniesienia danych
     */
    private static initSaveProjectForLogged() {
        ServiceSavePlannerProject.setSpinnerOnModal();
        ServiceSavePlannerProject.modalOn();
        ServiceSavePlannerProject.saveProject(
            ServiceSavePlannerProject.prepareDataToSend()
        )
            .done((response) => {
                ServiceSavePlannerProject.setContentOnModal(response)
            });
    }


    private static initSaveProjectForUnlogged(e) {
        e.preventDefault();
        let formData = ServiceSavePlannerProject.prepareDataToSend();
        ServiceSavePlannerProject.setSpinnerOnModal();
        ServiceSavePlannerProject.saveProject(
            formData
        )
            .done((response) => {
                ServiceSavePlannerProject.setContentOnModal(response)
            });
    }

    private static saveProjectBeforeLogin(e) {
        if (ServiceSavePlannerProject.isPlanerInit() && ServiceSavePlannerProject.isSaveClicked) {
            e.preventDefault();
            let formData = ServiceSavePlannerProject.prepareDataToSend({
                'wait_for_login': true
            });
            ServiceSavePlannerProject.saveProject(
                formData
            ).done(() => {
                e.currentTarget.submit()
            });
        }
    }

    /**
     * Zwraca dane do zapisu projektu
     */
    private static prepareDataToSend(extraSettings = null) {
        let formData = new FormData();
        if(extraSettings){
            $.each(extraSettings, function(index , value) {
                formData.append(index as string, value);
            });
        }
        formData.append('projectData', new Blob([ServiceSavePlannerProject.buffer], {type: 'application/octet-stream'}));
        formData.append('imgData', new Blob([ServiceSavePlannerProject.png], {type: 'image/png'}));
        formData.append('projectId', JSON.parse(ServiceSavePlannerProject.jsonData).id);
        formData.append('projectName', JSON.parse(ServiceSavePlannerProject.jsonData).name);

        if ($(PlannerSelectors.MODAL.SAVE_FOR_UNLOGGED.EMAIL).length > 0) {
            formData.append('email', $(PlannerSelectors.MODAL.SAVE_FOR_UNLOGGED.EMAIL).val() as string);
        }

        return formData;
    }

    /**
     * Zapisywanie projektu
     *
     * @param projectData
     * @param imgData
     */
    private static saveProject(formData) {
        return $.ajax({
            url: `${ServiceSavePlannerProject.ajaxUrl}save_planner_project/`,
            method: 'POST',
            contentType: false,
            processData: false,
            data: formData,
            dataType: 'html'
        })
    }

    private static loadModalSaveProjectForUnlogged() {
        return $.ajax({
            url: `${ServiceSavePlannerProject.ajaxUrl}load_modal_save_project_for_unlogged/`,
            method: 'POST',
            dataType: 'html'
        })
    }
}import * as $ from 'jquery';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import {on, onLoad, onSubmit} from 'Core/Events';
import {PlannerSubProcessCommon} from "Components/Planner/PlannerSubProcessCommon";

export class ServiceSavePlannerProject extends PlannerSubProcessCommon {

    private static buffer;
    private static png;
    private static jsonData;
    private static items;

    private static isSaveClicked = false;

    @on('eventLoginModalHasBeenClosed', ServiceSavePlannerProject.loadAndDisplayModalSaveProjectForUnlogged, PlannerSelectors.LOGIN_PANEL)
    @onSubmit(PlannerSelectors.MODAL.SAVE_FOR_UNLOGGED.FORM, ServiceSavePlannerProject.initSaveProjectForUnlogged)
    @onSubmit(PlannerSelectors.LOGIN_FORM, ServiceSavePlannerProject.saveProjectBeforeLogin)
    @onLoad(ServiceSavePlannerProject.showModalOnInit)

    public init(buffer, png, jsonData, items) {
        ServiceSavePlannerProject.buffer = buffer;
        ServiceSavePlannerProject.png = png;
        ServiceSavePlannerProject.jsonData = jsonData;
        ServiceSavePlannerProject.items = items;
        ServiceSavePlannerProject.isSaveClicked = true;

        ServiceSavePlannerProject.isUserLogged()
            .done((response) => {
                if (response.logged) {
                    ServiceSavePlannerProject.initSaveProjectForLogged();
                } else {
                    if($(PlannerSelectors.TOOGLER).length > 0){
                        $(PlannerSelectors.TOOGLER).click();
                    } else {
                        ServiceSavePlannerProject.loadAndDisplayModalSessionHasExpired();
                        ServiceSavePlannerProject.emergencyLoadingOfLoginForm()
                            .done(() => {
                                $(PlannerSelectors.TOOGLER).click();
                            })
                    }
                }
            });
    }

    public static loadAndDisplayModalSaveProjectForUnlogged(e) {
        if (ServiceSavePlannerProject.isSaveClicked) {
            ServiceSavePlannerProject.setSpinnerOnModal();
            ServiceSavePlannerProject.modalOn();
            ServiceSavePlannerProject.loadModalSaveProjectForUnlogged()
                .done((response) => {
                    ServiceSavePlannerProject.setContentOnModal(response)
                });
        }
    }

    /**
     * Inicjacja procesu przeniesienia danych
     */
    private static initSaveProjectForLogged() {
        ServiceSavePlannerProject.setSpinnerOnModal();
        ServiceSavePlannerProject.modalOn();
        ServiceSavePlannerProject.saveProject(
            ServiceSavePlannerProject.prepareDataToSend()
        )
            .done((response) => {
                ServiceSavePlannerProject.setContentOnModal(response)
            });
    }


    private static initSaveProjectForUnlogged(e) {
        e.preventDefault();
        let formData = ServiceSavePlannerProject.prepareDataToSend();
        ServiceSavePlannerProject.setSpinnerOnModal();
        ServiceSavePlannerProject.saveProject(
            formData
        )
            .done((response) => {
                ServiceSavePlannerProject.setContentOnModal(response)
            });
    }

    private static saveProjectBeforeLogin(e) {
        if (ServiceSavePlannerProject.isPlanerInit() && ServiceSavePlannerProject.isSaveClicked) {
            e.preventDefault();
            let formData = ServiceSavePlannerProject.prepareDataToSend({
                'wait_for_login': true
            });
            ServiceSavePlannerProject.saveProject(
                formData
            ).done(() => {
                e.currentTarget.submit()
            });
        }
    }

    /**
     * Zwraca dane do zapisu projektu
     */
    private static prepareDataToSend(extraSettings = null) {
        let formData = new FormData();
        if(extraSettings){
            $.each(extraSettings, function(index , value) {
                formData.append(index as string, value);
            });
        }
        formData.append('projectData', new Blob([ServiceSavePlannerProject.buffer], {type: 'application/octet-stream'}));
        formData.append('imgData', new Blob([ServiceSavePlannerProject.png], {type: 'image/png'}));
        formData.append('projectId', JSON.parse(ServiceSavePlannerProject.jsonData).id);
        formData.append('projectName', JSON.parse(ServiceSavePlannerProject.jsonData).name);

        if ($(PlannerSelectors.MODAL.SAVE_FOR_UNLOGGED.EMAIL).length > 0) {
            formData.append('email', $(PlannerSelectors.MODAL.SAVE_FOR_UNLOGGED.EMAIL).val() as string);
        }

        return formData;
    }

    /**
     * Zapisywanie projektu
     *
     * @param projectData
     * @param imgData
     */
    private static saveProject(formData) {
        return $.ajax({
            url: `${ServiceSavePlannerProject.ajaxUrl}save_planner_project/`,
            method: 'POST',
            contentType: false,
            processData: false,
            data: formData,
            dataType: 'html'
        })
    }

    private static loadModalSaveProjectForUnlogged() {
        return $.ajax({
            url: `${ServiceSavePlannerProject.ajaxUrl}load_modal_save_project_for_unlogged/`,
            method: 'POST',
            dataType: 'html'
        })
    }
}